import { border } from "../UI/tokens";
import styled from "styled-components";
import { btnReset, v } from "../../styles/variables";
import { Col } from "react-bootstrap";

export const STitleContainer = styled.div`
    /* width: ${(props) => (!props['data-isopen']  ? `auto` : v.sidebarWidth)}; */
    width: 100%;
    height: 70px;
    margin: 8px 0;
    border-radius: ${v.borderRadius};
`;

export const STituloTexto = styled.span`
    display: flex;
    color: inherit;
    font-size: 30px;
    padding: 0 20px;

font-size: clamp(22px, 2vw, 28px); font-weight: 650;
 line-height: 1.25; letter-spacing: -.6px; padding: 0; overflow-wrap: anywhere;

  align-items: center; gap: 12px; min-width: 0; font-weight: 600;
  & > span:last-child { min-width: 0; overflow-wrap: anywhere; }
`;  

export const STituloHeader = styled.div`
    width: 100%;
    margin: ${v.lgSpacing} 0;
`;

export const STituloDivider = styled.div`
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.bg3};

background: ${border}; margin: 16px 0 24px;
`;

export const STituloDivider2 = styled.div`
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.bg3};
`;

export const ColumnTitle = styled(Col)`
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;

justify-content: flex-start; min-height: 44px; margin-bottom: 8px;
`;